<div [ngClass]="{'error-background': data.msgError, 'normal-background': !data.msgError}">
  <div id="tituloArg">
    <h2 style="margin-right: 10px;" *ngIf="!data.msgError"><img width="45" src="../../../assets/icons/double_check.svg"></h2>
    <h2 style="margin-right: 10px;" *ngIf="data.msgError"><img width="45" src="../../../assets/icons/alert_icon.svg"></h2>
    <h2 style="margin-top: 5px;" [ngStyle]="{'color': data.msgError ? '#db5816' : '#294634'}">{{data.titulo}}</h2>
    <span style="flex: 1 1 auto;"></span>
  </div>
  <div >
    <div class="section-form-Arg">
      <div class="container-margin-Arg">
        <div *ngIf="data.lineas.length > 0">
          <p *ngFor="let linea of data.lineas" [ngStyle]="{'color': data.msgError ? '#db5816' : '#294634'}">
            {{linea}}
          </p>
        </div>
        <div *ngIf="data.lineas.length <= 0">
          <h3 style="text-align: center; color:#294634">Guardando...</h3>
          <mat-spinner style="width: 20em;height:20em;"></mat-spinner>
        </div>
      </div>
      <div class="container-margin-Arg">
        <div class="grid-container-Arg" style="justify-content: center">
          <mat-dialog-actions style="padding-right: 0">
            <button *ngIf="data.mostrarBtnCierre && data.msgError" mat-button mat-dialog-close class="boton-prin-Arg">Cerrar</button>
            <button *ngIf="data.mostrarBtnCierre && !data.msgError" mat-button mat-dialog-close class="boton-def-Arg">Cerrar</button>
            <button *ngIf="data.mostrarBtnAceptar" mat-button [mat-dialog-close]="false" class="boton-other-Arg">Cancelar</button>
            <button *ngIf="data.mostrarBtnAceptar" mat-button [mat-dialog-close]="true" class="boton-def-Arg">Aceptar</button>
          </mat-dialog-actions>
        </div>
      </div>
    </div>
  </div>
</div>
